import {
  apiHooks,
  type PhcPlatformRestEndpoints,
} from '@lifeomic/phc-web-toolkit/src/hooks/useRestAPIHooks';

export const FILE_VALIDATION_RESOLUTIONS_ROUTE =
  '/v1/member-operations/file-validation/resolutions';
export const FILE_VALIDATION_RESOLUTIONS_ENDPOINT =
  `POST ${FILE_VALIDATION_RESOLUTIONS_ROUTE}` as const;

export type FileValidationResolutionCommand =
  PhcPlatformRestEndpoints[typeof FILE_VALIDATION_RESOLUTIONS_ENDPOINT]['Request'];

export const useFileValidationResolutionCommand = () => {
  return apiHooks.useAPIMutation(FILE_VALIDATION_RESOLUTIONS_ENDPOINT);
};
